/*
 * @Description: 腾讯云sdk上传封装
 * @Author: luozhao
 * @Date: 2021-04-20 14:47:00
 */

import axios from 'axios'; //1
import COS from 'cos-js-sdk-v5'; // 腾讯云sdk //1
import SparkMD5 from 'spark-md5'; // 获取文件md5值插件 //1
import {
  bucketConfig
} from './config.js'; // 文件处理中心桶配置 各业务使用对应的桶配置  //1
import BetterStroage from '@/utils-khfw/betterStorage.service.js'; // 增强存储封装  //1
import {
  getToken
} from './token.service';
import dayJs from 'dayjs'
const REGION = `ap-shanghai`; // 存储区域。暂固定为上海
const SOURCE_TYPE = `198f031e785311e9bcfd00fec0a8c9c9`; // 其它 来源类型 暂固定为其它
const stroage = new BetterStroage();


class UploadService {
  constructor(params) {
    this.cosInstance = null;
    // appType 对应bucketConfig 桶的key，各个业务使用不同的桶
    this.bucketConfig = bucketConfig[params.appType];
    this.userInfo = params.userInfo;
    this.init();
  }
  init() {
    let _this = this;
    this.cosInstance = new COS({
      async getAuthorization(options, callback) {

        // const data = stroage.get('tencentCloudSign');
        // if (stroage.get('tencentCloudSign')) {

        //   // data.ExpiredTime = dayJs(data.ExpiredTime).unix()
        //   // data.ExpiredTime = dayJs(data.ExpiredTime).unix()
        //   callback(data);

        //   return false;
        // }
        // 异步获取临时密钥
        const accessToken = await getToken(); // 获取开放平台token
        axios
          .get(
            `https://gateway.tianyuyun.com/filecenter/getTempCredential`, {
            params: {
              appId: _this.bucketConfig.appId,
              bucket: options.Bucket,
              region: options.Region,
              accessToken: accessToken
            }
          }
          )
          .then(res => {
            const params = {
              TmpSecretId: res.data.data.tmpSecretId,
              TmpSecretKey: res.data.data.tmpSecretKey,
              XCosSecurityToken: res.data.data.sessionToken,
              ExpiredTime: res.data.data.expiration
            };
            params.ExpiredTime = dayJs(params.ExpiredTime).unix()
            callback(params);
            stroage.set('tencentCloudSign', params, 30 * 60 * 1000);
          });
      }
    });
  }
  upload(file, callback = {}) {
    return new Promise((resolve, reject) => {
      let fileExtension = file.name.split('.').pop().toLowerCase()
      let fileName = dayJs().unix() + '.' + fileExtension
      let filePath = this._createKey({
        platformCode: JSON.parse(window.sessionStorage.getItem("Userlist")).platformCode,
        userId: JSON.parse(window.sessionStorage.getItem("Userlist")).userId,
        fileName: fileName
      });
      console.log('上传文件路劲--->',filePath);
      this.cosInstance.putObject({
        Bucket: this.bucketConfig.sourceBucket,
        Region: REGION,
        Key: filePath,
        Body: file,
        onTaskReady: function (tid) {
          callback.onTaskReady && callback.onTaskReady(tid);
        },
        onTaskStart: function (info) {
          callback.onTaskStart && callback.onTaskStart(info);
        },
        onProgress: function (progressData) {
          callback.onProgress && callback.onProgress(progressData);
        }
      },
        async (err, data) => {
          console.log(data)
          console.log(err, '上传失败')
          const userToken = await getToken()
          if (!err) {
            if (data.statusCode === 200) {
              let hash = await this._transformFile2MD5(file);
              axios({
                url: `https://gateway.tianyuyun.com/filecenter/finishUploadFile?accessToken=${userToken}`,
                // url: `http://filecenter-test.tx.huijiaoyun.com/filecenter/upload/finishUploadFile`,
                method: 'post',
                data: {
                  filePath,
                  fileName: file.name,
                  sourceType: SOURCE_TYPE,
                  applyType: this.bucketConfig.appId,
                  fileMd5: hash,
                  userId: JSON.parse(window.sessionStorage.getItem("Userlist")).userId,
                  fileLength: file.size,
                  platformCode: "999999"
                }
              })
                .then(res => {
                  const data = res.data;
                  resolve(data);
                })
                .catch(err => {
                  console.log("失败")
                  reject(err);
                });
            }
          }
        }
      );
    });
  }
  _transformFile2MD5(file) {
    console.log(file)
    return new Promise((resolve, reject) => {
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      let chunkSize = 2097152; // Read in chunks of 2MB
      let chunks = Math.ceil(file.size / chunkSize);
      let currentChunk = 0;
      let spark = new SparkMD5.ArrayBuffer();
      let fileReader = new FileReader();

      fileReader.onload = function (e) {
        spark.append(e.target.result); // Append array buffer
        currentChunk++;

        if (currentChunk < chunks) {
          loadNext();
        } else {
          let hash = spark.end();
          resolve(hash);
        }
      };
      fileReader.onerror = function (err) {
        console.warn('oops, something went wrong.');
        reject(err);
      };
      // eslint-disable-next-line
      function loadNext() {
        let start = currentChunk * chunkSize;
        let end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;

        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
      }
      loadNext();
    });
  }

  /**
   * 生成上传文件目录
   * @param params
   * @returns {string}
   */
  _createKey(params) {
    // 平台编码+年月日时分+用户信息+uuid+文件名的方式
    const delimiter = '/';
    // const appPrefix = 'fe';
    const guid = this._guid();
    const platformCode = params.platformCode;
    const userId = params.userId;
    const fileName = params.fileName;
    const nowDate = new Date();
    const year = nowDate.getFullYear();
    const month =
      nowDate.getMonth() + 1 < 10 ?
        `0${nowDate.getMonth() + 1}` :
        nowDate.getMonth() + 1;
    const day =
      nowDate.getDate() < 10 ? `0${nowDate.getDate()}` : nowDate.getDate();
    const hour =
      nowDate.getHours() < 10 ? `0${nowDate.getHours()}` : nowDate.getHours();
    const minute =
      nowDate.getMinutes() < 10 ?
        `0${nowDate.getMinutes()}` :
        nowDate.getMinutes();
    const fileKey = `low/${platformCode}${delimiter}${year}${delimiter}${month}${delimiter}${day}${delimiter}${hour}${delimiter}${minute}${delimiter}${userId}${delimiter}${guid}${delimiter}${fileName}`;
    return fileKey;
  }

  /**
   * 生成唯一guid
   * @returns {string}
   */
  _guid() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (
      S4() +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      S4() +
      S4()
    );
  }
}

export default UploadService;